import { backendClient } from "@/api/backendClient";

import type {
  CaseTag,
  CaseTagInsert,
  CaseTagListQueryParams,
  CaseTagUpdate,
} from "@waku-care/types/contracts/internal";

export const getCaseTagById = async (id: string) => {
  const { data, error } = await backendClient.get<CaseTag>(`/case-tags/${id}`);
  if (error) throw error;
  return data;
};

export const getCaseTags = async (params?: CaseTagListQueryParams) => {
  const { data, count, error } = await backendClient.get<CaseTag[]>(`/case-tags`, { params });
  if (error) throw error;
  return { data, count };
};

export const createCaseTag = async ({ values }: { values: CaseTagInsert }) => {
  const { data, error } = await backendClient.post<CaseTag>(`/case-tags`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

export const updateCaseTagById = async ({ id, values }: { id: string; values: CaseTagUpdate }) => {
  const { data, error } = await backendClient.patch<CaseTag>(`/case-tags/${id}`, {
    body: values,
  });
  if (error) throw error;
  return data;
};

export const deleteCaseTagById = async (id: string) => {
  const { error } = await backendClient.delete<void>(`/case-tags/${id}`);
  if (error) throw error;
};
